import React from "react"

const MorningApptBanner = () => (
  <section>
    <div className="consent-announcement">
      <img
        alt="warning-circle.svg"
        height="24"
        src="/images/WarningCircle.svg"
        width="24"
      />
      To speak with an Enrollment Specialist, please call{" "}
      <a href="tel:888-885-5068">888-885-5068</a>
    </div>
  </section>
)

export default MorningApptBanner
